import { DelegateMixin } from "../../../core/media/delegate.js";
import { MediaProxyMixin } from "../proxy.js";
import { CustomMediaMixin } from "../custom-media-element/index.js";
import { HlsMediaTextTracksMixin } from "./text-tracks.js";
import Hls from "hls.js";

//#region src/dom/media/hls/index.ts
const defaultConfig = {
	backBufferLength: 30,
	renderTextTracksNatively: false,
	liveDurationInfinity: true,
	capLevelToPlayerSize: true,
	capLevelOnFPSDrop: true
};
var HlsMediaDelegateBase = class {
	#engine = Hls.isSupported() ? new Hls(defaultConfig) : null;
	get engine() {
		return this.#engine;
	}
	attach(target) {
		this.#engine?.attachMedia(target);
	}
	detach() {
		this.#engine?.detachMedia();
	}
	destroy() {
		this.#engine?.destroy();
	}
	set src(src) {
		this.#engine?.loadSource(src);
	}
	get src() {
		return this.#engine?.url ?? "";
	}
};
const HlsMediaDelegate = HlsMediaTextTracksMixin(HlsMediaDelegateBase);
var HlsCustomMedia = class extends DelegateMixin(CustomMediaMixin(globalThis.HTMLElement ?? class {}, { tag: "video" }), HlsMediaDelegate) {};
var HlsMedia = class extends DelegateMixin(MediaProxyMixin, HlsMediaDelegate) {};

//#endregion
export { HlsCustomMedia, HlsMedia, HlsMediaDelegateBase };
//# sourceMappingURL=index.js.map